import React from 'react';
import { TabType, TabComponent } from '@src/slide/application/service/slide-rating-and-improve/view/mobile/result/title-alignment-preview/tab';
import Button from '@tencent/dui-mobile/lib/components/Button';
import i18n from '@i18next/i18n';
import Style from './title-alignment-preview.less';
import {
    SlideSwiper,
} from '@src/slide/application/service/slide-rating-and-improve/view/mobile/result/title-alignment-preview/slide-swiper';
import {
    IShowContentChangeOption,
} from '@src/slide/application/service/slide-rating-and-improve/content-layout/result/title-alignment-result';
import { tdw } from '@src/slide/infrastructure/module/dependent/report/offline-data-report/tdw-report';
import {
    TDWActionType,
    TDWModuleType,
    TDWOperationType,
} from '@src/slide/infrastructure/module/dependent/report/offline-data-report/constant';

export interface TitleAlignmentPreviewProps {
    options: IShowContentChangeOption;
    contentSize: {
        width: number;
        height: number;
    }
    onConfirm: () => void;
}

export interface TitleAlignmentPreviewState {
    tabType: TabType;
    currentShowIndex: number;
}

export class TitleAlignmentPreview extends React.Component<TitleAlignmentPreviewProps, TitleAlignmentPreviewState> {
    public constructor(props: TitleAlignmentPreviewProps) {
        super(props);
        this.state = {
            tabType: TabType.Adjusted,
            currentShowIndex: 0,
        };
    }

    public render() {
        const { options } = this.props;
        return (
            <div style={{ height: '100%' }}>
                <TabComponent onTabChange={this.changeTab.bind(this)} />
                <div className={Style['tab-content']}>
                    <div className={Style['slide-content-wrapper']}>
                        <div style={{
                            width: '100%',
                            height: `${this.props.contentSize.height}px`,
                            marginTop: '16px',
                            display: this.state.tabType === TabType.Adjusted ? 'block' : 'none',
                        }}>
                            <SlideSwiper
                                slideWidth={options.slideWidth}
                                slideHeight={options.slideHeight}
                                contentSize={this.props.contentSize}
                                slideArray={options.toChangeSlideList}
                                currentIndex={this.state.currentShowIndex}
                                onChangeIndex={this.onChangeIndex}
                            />
                        </div>
                        <div style={{
                            width: '100%',
                            height: `${this.props.contentSize.height}px`,
                            marginTop: '16px',
                            display: this.state.tabType === TabType.Before ? 'block' : 'none',
                        }}>
                            <SlideSwiper
                                slideWidth={options.slideWidth}
                                slideHeight={options.slideHeight}
                                contentSize={this.props.contentSize}
                                slideArray={options.originSlideList}
                                currentIndex={this.state.currentShowIndex}
                                onChangeIndex={this.onChangeIndex}
                            />
                        </div>
                        <div className={Style['slide-content-number-wrapper']}>
                            <div
                                className={Style['slide-content-number-current']}>{this.state.currentShowIndex + 1}</div>
                            <div
                                className={Style['slide-content-number-total']}>{`/${options.toChangeSlideList.length}`}</div>
                        </div>
                        <Button
                            type='primary'
                            className={Style['confirm-button']}
                            onClick={this.props.onConfirm}
                        >{i18n.t('确认调整')}</Button>
                    </div>
                </div>
            </div>
        );
    }

    public componentDidMount() {
        tdw({
            opername: TDWOperationType.DOC_PPT,
            module: TDWModuleType.AUTO_BEAUTIFY,
            action: TDWActionType.BEAUTIFY_TITLE_ALIGNMENT_VIEW,
        });
    }

    private changeTab(tabType: TabType) {
        this.setState({ tabType });
    }

    private onChangeIndex = (index: number) => {
        this.setState({ currentShowIndex: index });
    };
}

